import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Spinner from '../../../components/common/Spinner';
import { accountDetailsRequest } from '../../../modules/account/actions';
import {
  canChangeOmniPIN,
  canSetOmniPIN,
  getCardNumber,
  isDetailsPending
} from '../../../modules/account/selectors';
import {
  CHANGE_NUMBER,
  LOST_CARD,
  MARKETING_PREFERENCES,
  OMNI_SET_PIN
} from '../../../routes/paths';
import FormMessage from '../../FormMessage';
import Translation from '../../i18n/Translation';

export class Settings extends React.Component {
  componentDidMount() {
    const {
      onLoad = () => {
      }
    } = this.props;

    onLoad();
  }

  render() {
    const {
      cardNumber,
      showSpinner,
      canSetPIN,
      canChangePIN,
      history
    } = this.props;

    return (
      <div className="settings">
        <div className="container--fixed">
          <FormMessage className="settings__form-message" />
        </div>
        <div className="settings__content">
          <div className="container--fixed">
            <h2 className="settings__header">
              <Translation section="settings" label="cardNumber" />
            </h2>
            <p className="settings__info settings__spinner">
              {
                (showSpinner)
                  ? (<Spinner className="spinner--small" />)
                  : (cardNumber)
              }
            </p>
            { (canSetPIN || canChangePIN) && (
              <div className="settings__section" onClick={() => history.push(OMNI_SET_PIN)}>
                <h4 className="settings__section-name">
                  <Translation
                    section="settings"
                    label={canSetPIN ? 'setPINTitle' : 'changePINTitle'}
                  />
                </h4>
                <p className="settings__section-content">
                  <Translation
                    section="settings"
                    label={canSetPIN ? 'setPINDesc' : 'changePINDesc'}
                  />
                </p>
              </div>
            ) }
            <div className="settings__section" onClick={() => history.push(CHANGE_NUMBER)}>
              <h4 className="settings__section-name">
                <Translation section="settings" label="changeNumberTitle" />
              </h4>
              <p className="settings__section-content">
                <Translation section="settings" label="changeNumberDesc" />
              </p>
            </div>
            <div className="settings__section" onClick={() => history.push(LOST_CARD)}>
              <h4 className="settings__section-name">
                <Translation section="settings" label="lostCardTitle" />
              </h4>
              <p className="settings__section-content">
                <Translation section="settings" label="lostCardDesc" />
              </p>
            </div>
            <div className="settings__section" onClick={() => history.push(MARKETING_PREFERENCES)}>
              <h4 className="settings__section-name">
                <Translation section="settings" label="preferencesTitle" />
              </h4>
              <p className="settings__section-content">
                <Translation section="settings" label="preferencesDsc" />
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Settings.propTypes = {
  cardNumber: PropTypes.string,
  showSpinner: PropTypes.bool,
  canSetPIN: PropTypes.bool,
  canChangePIN: PropTypes.bool,
  onLoad: PropTypes.func,
  history: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  cardNumber: getCardNumber(state),
  showSpinner: isDetailsPending(state),
  canSetPIN: canSetOmniPIN(state),
  canChangePIN: canChangeOmniPIN(state)
});

const mapDispatchToProps = {
  onLoad: accountDetailsRequest
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Settings));
